import { Box } from '@rbilabs/universal-components';

import { spacing } from 'styles/constants';

export const LogoContainer = Box.withConfig({
  marginRight: spacing.$0_5,
  justifyContent: 'center',
});
